import { Component, h, State } from '@stencil/core';
import state, { store } from '@ugc-store';
import { Minus, Plus } from '../../icons/index';
import { FilterType } from '@ugc-components/ugc-pdp-question-and-answer/interfaces';
import { requestListData } from '@ugc-components/ugc-pdp-question-and-answer/utils';
import { addDataLayer } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-qna-sort-filter-modal',
  shadow: false,
})
export class UgcQnaSortFilterModal {
  @State() localSortId = state.sortId;
  @State() isOpenSortId = false;
  @State() localCid = state.cid;
  @State() isOpenCid = false;

  componentShouldUpdate() {
    store.onChange('isShowQnaFilterModal', () => {
      if (this.localSortId !== state.sortId) {
        this.localSortId = state.sortId;
      }
      if (this.localCid !== state.cid) {
        this.localCid = state.cid;
      }
    });
  }

  handleDataLayer = () => {
    const dataLayerData = {
      filters: [`topic=${this.localCid}`, `sort=${this.localSortId}`],
    };
    addDataLayer({
      event: 'form_submit',
      form_submit: {
        name: 'qna filter',
        complete: true,
        type: 'dynamic',
        error: '',
        data: dataLayerData,
      },
    });
  };

  toggleDrawer = id => {
    if (id === FilterType.sortId) {
      this.isOpenSortId = !this.isOpenSortId;
    } else {
      this.isOpenCid = !this.isOpenCid;
    }
  };

  handleUpdateSortId = value => {
    this.localSortId = Number(value);
  };
  handleUpdateCid = value => {
    this.localCid = Number(value);
  };

  handleSubmit = () => {
    state.sortId = this.localSortId;
    state.cid = this.localCid;
    state.isShowQnaFilterModal = false;
    requestListData();
    this.handleDataLayer();
    this.resetDrawerBar();
  };

  handleCancel = () => {
    this.resetDrawerBar();
    state.isShowQnaFilterModal = false;
  };

  resetDrawerBar = () => {
    this.isOpenSortId = false;
    this.isOpenCid = false;
  };

  render() {
    const {
      isShowQnaFilterModal,
      sorterList,
      categoryList,
      qnaStaticLanguage: {
        IDS_UGC_QNA_SORT_FILTER_TITLE,
        IDS_UGC_QNA_MODAL_APPLY,
        IDS_UGC_QNA_SORT_BY,
        IDS_UGC_CATEGORY,
      },
    } = state;
    const filterSorter = sorterList.find(item => item.id === this.localSortId);
    const filterCid = categoryList.find(item => item.id === this.localCid);
    const filterOptions = [
      {
        id: FilterType.sortId,
        name: IDS_UGC_QNA_SORT_BY,
        label: filterSorter ? filterSorter.name : '',
        options: sorterList.map(item => ({ value: String(item.id), content: item.name, name: 'sortId' })),
        value: String(this.localSortId),
        isOpen: this.isOpenSortId,
        dataTestId: 'qna-select-sort',
        handleChange: this.handleUpdateSortId,
      },
      {
        id: FilterType.cid,
        name: IDS_UGC_CATEGORY,
        label: filterCid ? filterCid.name : '',
        options: categoryList.map(item => ({ value: String(item.id), content: item.name, name: 'cid' })),
        value: String(this.localCid),
        isOpen: this.isOpenCid,
        dataTestId: 'qna-select-topic',
        handleChange: this.handleUpdateCid,
      },
    ];
    return (
      <div class="w-full">
        <ugc-drawer
          isShow={isShowQnaFilterModal}
          modalTitle={IDS_UGC_QNA_SORT_FILTER_TITLE}
          submitButtonText={IDS_UGC_QNA_MODAL_APPLY}
          isConfirm={true}
          isShowCloseButton={true}
          isGray
          handleSubmit={this.handleSubmit}
          handleCancel={this.handleCancel}
        >
          {isShowQnaFilterModal && (
            <div class="p-24" style={{ minHeight: '70vh' }}>
              {filterOptions.map(item => {
                const { id, options, value, handleChange, name, isOpen, label, dataTestId } = item;
                return (
                  <div key={id} data-testid={dataTestId}>
                    <div class="mb-16 p-16 bg-white rounded-8">
                      <div class="flex-row-between-center py-8" onClick={() => this.toggleDrawer(id)}>
                        <div class="flex-col-start-start">
                          <div class="drawer-item-name fs-14 bold c-333">{name}</div>
                          {!isOpen && (
                            <span class="mt-4 fs-12 color-green-dark" data-testid="selected-option">
                              {label}
                            </span>
                          )}
                        </div>
                        <div class="drawer-button flex-row-end-center">
                          {isOpen ? <Minus width="20" height="20" /> : <Plus width="20" height="20" />}
                        </div>
                      </div>
                      {isOpen && (
                        <div class="px-16">
                          <ugc-radio-group value={value} radioChange={handleChange} options={options} />
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </ugc-drawer>
      </div>
    );
  }
}
